// extracted by mini-css-extract-plugin
export default {"actions":"device_actions__qgXNd","calendar":"device_calendar__3Mj3d","link-on":"device_link-on__AOF-h","link-off":"device_link-off__0cdBl"};